import * as React from 'react';
import { SVGProps } from 'react';

const FileIconMovSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 17v16H9V17h16Zm-2.823.889h1.882v.993h-1.883v-.993Zm0 14.222h1.882v-.993h-1.883v.993Zm0-1.934h1.882v-1.883h-1.883v1.883Zm0-2.824h1.882V25.47h-1.883v1.882Zm-.942-1.882v6.64h-8.47v-6.64h8.47Zm0-.942h-8.47v-6.64h8.47v6.64Zm.942 0h1.882v-1.882h-1.883v1.882Zm0-2.823h1.882v-1.883h-1.883v1.883Zm-10.354.941v1.882H9.941v-1.882h1.882Zm-1.882 4.706V25.47h1.882v1.882H9.941Zm0 .941v1.883h1.882v-1.883H9.941Zm0 3.817v-.993h1.882v.993H9.941Zm1.882-10.405v-1.883H9.941v1.883h1.882Zm-1.882-3.817v.993h1.882v-.993H9.941Z"
      fill="#fff"
    />
    <path
      d="M12.5 7.382a1.494 1.494 0 0 0-1.7-.209V7H10v5h1V8.5a.5.5 0 0 1 1 0V12h1V8.5a.5.5 0 0 1 1 0V12h1V8.41l-.003-.002A1.5 1.5 0 0 0 12.5 7.382Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 10.4c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-.6c-.58 0-1.01-.127-1.29-.38-.273-.253-.41-.66-.41-1.22V8.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h.6c.58 0 1.007.127 1.28.38.28.253.42.66.42 1.22v1.8Zm-1-1.75c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.5c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h.5c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7Z"
      fill="#fff"
    />
    <path d="M21 7h1v3h1V7h1v3l-1 2h-1l-1-2V7Z" fill="#fff" />
  </svg>
);
export default FileIconMovSizeM;
